import { unit } from './IMetricCode'
import { TearsheetJobStatus, TearsheetState, TearsheetUnit } from '../enums/tearsheet/TearsheetState' // Ensure this path is correct

export interface ITearSheet {
    mnemonic: string,
    name:string,
    locked?: boolean,
    noOperatingMetrics?: boolean,
    generalInfo: ITearsheetCompanyInfo,
    investmentSummary: IInvestmentSummary,
    investmentProfile: IInvestmentProfile,
    fundInvestmentSummary: IFundInvestmentSummary[],
    keyOperatingStats: IKeyOperatingStats,
    commentary: ITearsheetCommentary,
    pmtReview?:boolean,
	complianceReview?:boolean,
	clientServiceReview?:boolean,
	state?:TearsheetState,
    includeInTearsheet?:boolean,
    footer?:string;
    investmentSummaryWithExcludePartner?: IInvestmentSummary;
    investmentSummaryWithExcludePartnerForAggregatedPDF?: IInvestmentSummary;
}

export interface ITearsheetCompanyInfo {
    name?: string,
    logo?: string,
    website?: string,
    funds?: string[],
    /** Overall date for the tearsheet. All investment returns will be 'asOf'
     * This date.*/
    tearSheetDate?: Date,

    /**
     * Date for the operating metrics. This should be consistent across all
     * metrics in the tearsheet.
     */
    operatingMetricsDate?: Date,

    /**
     * List of the Quantum directors of the company as email addresses.
     */
    quantumDirectors?: string[],
}

export interface IInvestmentProfile {
    [key: string]: IMetricProps | null
    
}

// Investment Summary at a company level
export interface IInvestmentSummary {
    totalCommitment?: IMetricProps,
    investedCapital?: IMetricProps,
    distributions?: IMetricProps,
    holdingValue?: IMetricProps,
    totalValue?: IMetricProps,
    enterpriseValue?: IMetricProps,

    /**
     * Realized moic is synonym for distributions / invested capital.
     * Net is after fees (using fund-level ratio supplied IR).
     */
    grossRealizedMoic?: IMetricProps,
    netRealizedMoic?: IMetricProps,
    adjustedRealizedMoic?:IMetricProps,

    /**
     * Unrealized moic
     */
    grossUnrealizedMoic?: IMetricProps,
    netUnrealizedMoic?: IMetricProps,
    adjustedUnrealizedMoic?: IMetricProps,
    
    grossTotalMoic?: IMetricProps,
    netTotalMoic?: IMetricProps,
    adjustedTotalMoic?:IMetricProps,

    /**
     * irr is time based, and requires accurate cash flow information.
     */
    grossIrr?: IMetricProps,
    netIrr?: IMetricProps,
    adjustedIrr?:IMetricProps,
}

// Investment Summary at an fund investor level
export interface IFundInvestmentSummary extends IInvestmentSummary {
    fund: IMetricProps,
    sharingRatio?: IMetricProps,
}


export interface IKeyOperatingStats {
    [key: string]: IMetricProps | null
}

export interface ITearsheetCommentary {
    companyOverview?: string,
    investmentThesis?: string,
    significantDevelopments?: string
}

export interface IMetricProps {
    displayName?: string,
    value?: string | number | Date | null
    unit?: unit,
    isEdit?: boolean,
    metricCode?: string,
    tearsheetNameStyles?: string,
    tearsheetValueStyles?: string,
    periodEndDate?: Date,
    metricName?: string
}

export interface ICompanyList {
    mnemonic?: string,
    name?: string,
    legalName?: string
}

export enum TearsheetSections {
    investmentProfile = 'investmentProfile',
    keyOperatingStats = 'keyOperatingStats',
    investmentSummary = 'investmentSummary',
    fundInvestmentSummary = 'fundInvestmentSummary'
}

export interface ITearsheetGeneratorPDF {
    pdfBuffer: any;
    pdfHeightFlag: boolean;
    positionMap?: { [key: string]: number };
    filePath?: string;
}
export interface ITearsheetGeneratorHTML {
    html: string;
    pdfHeightFlag: boolean;
}

export enum CompanyMetricOverrides{
    AR = 'AR'
}

interface MetricOverride {
    metricCode: string;
    unit: string;
    metricName: string;
    displayName: string;
    categoryCode: string;
}

export interface ITearsheetJobData {
  fundName: string;
  quarter: string;
  status: TearsheetJobStatus.queued | TearsheetJobStatus.running | TearsheetJobStatus.completed | TearsheetJobStatus.failed;
  error?: string;
}

export interface ITearsheetJobStatus {
    combinedStatus: string;
    jobStatus: ITearsheetJobData[];
    error: string;
}